import { render, staticRenderFns } from "./EditPartnerSettingsForm.vue?vue&type=template&id=4ee7ec76&"
import script from "./EditPartnerSettingsForm.vue?vue&type=script&lang=js&"
export * from "./EditPartnerSettingsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports